import React from 'react'
import _ from 'lodash'
import { Map } from 'immutable'
import { connect } from 'react-redux'
import { Clipboard, TouchableOpacity } from 'react-native'

import * as util from 'x/utils/util'
import { getStoreSelected, getSelectedProduct } from 'x/redux/selectors'
import * as NavActions from 'x/utils/navigation'
import api from 'x/utils/api'
import p from 'x/config/platform-specific'
import { ISelectedStoreMap, IXScreenProps } from 'x/index'
import XContainer from 'xui/components/XContainer'
import XContent from 'xui/components/XContent'
import XCustomHeader from 'xui/components/XCustomHeader'
import HStack from 'xui/components/HStack'
import XText from 'xui/components/XText'
import VStack from 'xui/components/VStack'
import { COLORS, STYLES } from 'x/config/styles'
import XOverlay from 'xui/components/XOverlay'
import XInput from 'xui/components/XInput'
import XSpinner from 'xui/components/XSpinner'

interface IProps extends IXScreenProps {
  selectedStore: ISelectedStoreMap
}

interface IState {
  isVisibleOverlay: boolean
  indexOpenConfirmMigrate: number
  confirmText: string

  isVisibleLoadingOverlay: boolean
}

class ContactMigrateView extends React.Component<IProps, IState> {
  static displayName = 'ContactMigrateView'

  constructor(props) {
    super(props)
    this.state = {
      isVisibleOverlay: false,
      indexOpenConfirmMigrate: 1,
      confirmText: '',
      isVisibleLoadingOverlay: false,
    }
  }

  // async componentDidMount() {}

  _onPressConfirmMigrate = async () => {
    const { selectedStore } = this.props
    await util.setStatePromise(this, {
      isVisibleOverlay: false,
      indexOpenConfirmMigrate: 1,
      confirmText: '',
    })
    this.setState({ isVisibleLoadingOverlay: true })
    // Call API to migrate contacts
    const apiOptions = {
      showSpinner: true,
    }
    const body: { [key: string]: any } = {
      migrate_to_store_id: selectedStore.get('id'),
    }
    const res = await api.postV2(api.POST_CONTACT_MIGRATE_FROM_PROFILE, body, apiOptions)
    // console.log('res => ', res)
    if (res.status === 'ok') {
      await util.setStatePromise(this, {
        isVisibleLoadingOverlay: false,
      })
      const params = util.getNavParams(this.props)
      const { callBackSucceedMigrate } = params
      if (_.isFunction(callBackSucceedMigrate)) {
        callBackSucceedMigrate()
      }
      util.navGoBack(this.props)
      p.op.showToast('ย้ายรายชื่อลูกค้าเรียบร้อยแล้ว', 'success')
      return
    }
    p.op.showToast('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', 'warning')
  }

  _renderCustomHeader = () => {
    return (
      <XCustomHeader
        title='ย้ายรายชื่อลูกค้า'
        headerLeftProps={{ backIcon: true, onPressItem: () => util.navGoBack(this.props) }}
        headerRightProps={{ label: ' ', onPressItem: () => null }}
      />
    )
  }

  _renderDescription = () => {
    return (
      <VStack w={'full'} p='2'>
        <XText>
          {
            'โดยปกติ รายชื่อลูกค้าที่เห็นในเมนู "อื่นๆ > ลูกค้า" จะเป็นรายชื่อลูกค้าเฉพาะแต่บัญชีที่ใช้งาน XSelly ทำให้ไม่สามารถแชร์รายชื่อระหว่างเจ้าของร้านและแอดมินในร้านได้ เนื่องด้วยว่า XSelly มีฟีเจอร์ "รายชื่อลูกค้า" (แบบใหม่) ที่สามารถแชร์รายชื่อระหว่างเจ้าของร้านและแอดมินในร้านได้  คุณสามารถทำการย้ายรายชื่อลูกค้าแบบเก่าที่คุณสร้างไว้ ไปรวมกันใน "รายชื่อลูกค้า" ของร้านได้ โดยกดปุ่ม "ย้ายรายชื่อลูกค้า" ด้านล่าง'
          }
        </XText>
        <XText mt='10' color={COLORS.RED}>
          หมายเหตุ*1 อนาคตรายชื่อลูกค้าแบบเก่าจะไม่สามารถใช้งานได้อีก
        </XText>
        <XText mt='2' color={COLORS.RED}>
          หมายเหตุ*2 หากคุณมีหลายร้านค้า เนื่องจากการย้ายรายชื่อลูกค้าจะทำให้รายชื่อลูกค้าจะแสดงผลแค่ในร้านค้าที่ย้ายเท่านั้น
          หากต้องการให้รายชื่อลูกค้าแสดงผลในร้านค้าอื่นๆด้วย กรุณาติดต่อทีมงานที่ LINE: @XSelly
        </XText>
      </VStack>
    )
  }

  _renderMigrateButton = () => {
    return (
      <VStack w='full' alignItems={'center'} justifyContent={'center'} p='2'>
        <XText>กดปุ่ม "ย้ายรายชื่อลูกค้า" เพื่อดำเนินการย้ายลูกค้า</XText>
        <TouchableOpacity
          style={{
            borderRadius: 90,
            backgroundColor: COLORS.APP_MAIN,
            alignItems: 'center',
            justifyContent: 'center',
            padding: 12,
            marginTop: 12,
          }}
          onPress={() =>
            this.setState({
              isVisibleOverlay: true,
            })
          }>
          <XText color={COLORS.WHITE}>ย้ายรายชื่อลูกค้า</XText>
        </TouchableOpacity>
      </VStack>
    )
  }

  _renderOverlayConfirmMigrate = () => {
    const { isVisibleOverlay, indexOpenConfirmMigrate, confirmText } = this.state
    const renderPageOne = () => (
      <VStack h={p.op.isWeb() ? '180px' : '40'}>
        <VStack bgColor='amber.100' p='2'>
          <XText>การย้ายบัญชีรายชื่อลูกค้า จะทำให้รายชื่อลูกค้าจะไปย้ายไปอยู่ในรายชื่อลูกค้าแบบใหม่ และแบบเก่าก็จะถูกลบออกจากระบบ</XText>
          <XText mt='4'>คุณต้องการดำเนินการย้ายบัญชีรายชื่อลูกค้าหรือไม่?</XText>
        </VStack>

        <HStack space={'2'} p='2' flex={1}>
          <TouchableOpacity
            onPress={() => this.setState({ indexOpenConfirmMigrate: 2 })}
            style={{ borderRadius: 90, backgroundColor: COLORS.RED, flex: 1, alignItems: 'center', justifyContent: 'center' }}>
            <XText color={COLORS.WHITE} bold py='2'>
              ดำเนินการต่อ
            </XText>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ isVisibleOverlay: false, indexOpenConfirmMigrate: 1, confirmText: '' })}
            style={{
              borderRadius: 90,
              backgroundColor: COLORS.WHITE,
              borderColor: COLORS.APP_MAIN,
              borderWidth: 1,
              flex: 1,
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <XText color={COLORS.APP_MAIN} bold py='2'>
              ยกเลิก
            </XText>
          </TouchableOpacity>
        </HStack>
      </VStack>
    )

    const renderPageTwo = () => (
      <VStack h='48'>
        <VStack p='2'>
          <XText>เพื่อยืนยันการลบบัญชี กรุณาพิมพ์คำว่า CONFIRM (ตัวพิมพ์ใหญ่ทุกตัว) ในช่องด้านล่างและกดปุ่ม ย้ายรายชื่อ</XText>
        </VStack>
        <XInput
          style={{ minHeight: 34, padding: 8, margin: 2, fontSize: STYLES.FONT_SIZE_LARGER }}
          flex={1}
          textAlign='center'
          textAlignVertical='center'
          placeholder='พิมพ์ CONFIRM เพื่อย้ายบัญชีลูกค้า'
          value={confirmText}
          onChangeText={(text: string) => this.setState({ confirmText: text })}
        />
        <HStack space={'2'} p='2' flex={1}>
          <TouchableOpacity
            disabled={confirmText !== 'CONFIRM'}
            onPress={() => {
              this._onPressConfirmMigrate()
            }}
            style={{
              borderRadius: 90,
              backgroundColor: confirmText !== 'CONFIRM' ? COLORS.TEXT_INACTIVE : COLORS.RED,
              flex: 1,
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <XText color={COLORS.WHITE} bold py='2'>
              ย้ายรายชื่อ
            </XText>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ isVisibleOverlay: false, indexOpenConfirmMigrate: 1, confirmText: '' })}
            style={{
              borderRadius: 90,
              backgroundColor: COLORS.WHITE,
              borderColor: COLORS.APP_MAIN,
              borderWidth: 1,
              flex: 1,
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <XText color={COLORS.APP_MAIN} bold py='2'>
              ยกเลิก
            </XText>
          </TouchableOpacity>
        </HStack>
      </VStack>
    )
    return (
      <XOverlay
        visible={isVisibleOverlay}
        onRequestClose={() => this.setState({ isVisibleOverlay: false, indexOpenConfirmMigrate: 1, confirmText: '' })}>
        <XCustomHeader title='ย้ายรายชื่อลูกค้า' />
        {indexOpenConfirmMigrate === 1 ? renderPageOne() : renderPageTwo()}
      </XOverlay>
    )
  }

  _renderOverlayLoading = () => {
    const { isVisibleLoadingOverlay } = this.state
    return (
      <XOverlay visible={isVisibleLoadingOverlay}>
        <VStack h='32' alignItems='center' justifyContent='center' space='2' w='full'>
          <XSpinner />
          <XText>กำลังย้ายรายชื่อลูกค้า...</XText>
          <XText>กรุณารอซักครู่ อาจใช้เวลาหลายนาที</XText>
        </VStack>
      </XOverlay>
    )
  }

  _renderContent = () => {
    return (
      <VStack w={'full'}>
        {this._renderDescription()}
        {this._renderMigrateButton()}
      </VStack>
    )
  }

  render() {
    // const renderNavReference = util.getNavParam(this.props, 'renderNavReference')

    return (
      <XContainer>
        {this._renderCustomHeader()}
        {/* {this._renderSearchBar()} */}

        <XContent style={{ backgroundColor: 'white' }}>
          {this._renderContent()}
          {this._renderOverlayConfirmMigrate()}
          {this._renderOverlayLoading()}
        </XContent>

        {/* {this._renderAddProductToBundleButton()} */}
      </XContainer>
    )
  }
}

export default connect(
  (state) => ({
    selectedStore: getStoreSelected(state),
    // selectedProduct: getSelectedProduct(state),
    // mkpChannels: getMkpChannels(state),
  }),
  (dispatch) => ({
    dispatch,
  })
)(ContactMigrateView)
